
import state from './usersState.js'
import * as mutations from './usersMutations.js'
import * as actions from './usersActions.js'
import * as getters from './usersGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}